var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.unableToWorkDays === 'number')?_c('div',[_vm._v(" "+_vm._s(_vm.unableToWorkDays)+" "+_vm._s(_vm.$t("incidentReports.days"))+" ")]):_c('div',[_vm._v(_vm._s(_vm.unableToWorkDays))])
}
var staticRenderFns = []

export { render, staticRenderFns }